/* eslint-disable @typescript-eslint/dot-notation */
import { Component, OnInit } from '@angular/core';
import { AbTestingService } from 'src/app/services/ab-testing/ab-testing.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
import { ThemeService } from 'src/app/services/client/theme/theme.service';
declare function initDrift(): Promise<boolean>;
declare function openDrift(): void;
declare function isDriftReady(): boolean;
@Component({
  selector: 'support-widget',
  templateUrl: './support-widget.component.html',
  styleUrls: ['./support-widget.component.scss'],
})
export class SupportWidgetComponent implements OnInit {
  public driftActive: boolean;
  public wpChatSupport: boolean;
  public pid: string | undefined;
  constructor(
    private analyticsService: AnalyticsService,
    public themeService: ThemeService,
    private abTestingService: AbTestingService
  ) {
    this.driftActive = isDriftReady() || false;
  }

  async ngOnInit() {
    this.pid = this.themeService.getAppPid ?? '';
    if (!this.driftActive) {
      initDrift().then((isActive) => {
        this.driftActive = isActive;
      });
    }
    if (this.themeService.getChatSupport) {
      this.wpChatSupport = true;
    }
  }

  onClick() {
    if (this.pid !== 'bfl') {
      this.analyticsService.trackUnified('support_chat_clicked', {
        flow: 'support',
        outcome: 'success',
        legacy_event_name: 'Support Widget Chat Button',
        component: 'support-widget-component',
        button: 'chat-button',
        experimentName: 'accountsupportwidgettop',
        experimentVariant:
          this.abTestingService.experimentArray['accountsupportwidgettop'],
      });
      if (this.themeService.getChatSupport) {
        const message = 'Hello! I need help with Travel VIP.';
        const whatsappUrl = `https://wa.me/${
          this.themeService.getChatSupport
        }?text=${encodeURIComponent(message)}`;
        window.open(whatsappUrl, '_blank');
      } else {
        openDrift();
      }
    }
  }
  handleEmailSupport() {
    if (this.pid !== 'bfl') {
      this.analyticsService.trackUnified('support_email_clicked', {
        flow: 'support',
        outcome: 'success',
        legacy_event_name: 'Support Widget Email Button',
        component: 'support-widget-component',
        button: 'email-button',
        experimentName: 'accountsupportwidgettop',
        experimentVariant:
          this.abTestingService.experimentArray['accountsupportwidgettop'],
      });
      const subject = 'Travel VIP Support Request';
      const body = 'Hello, I need assistance with Travel VIP.';
      const mailtoUrl = `mailto:${
        this.themeService.getEmailSupport
      }?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.open(mailtoUrl);
    }
  }

  // getFormattedPhoneNumber(): string {
  //   const phoneNumber = this.themeService.getChatSupport;
  //   if (!phoneNumber) return '';
    
  //   // Remove the country code "91" if it exists at the beginning
  //   if (phoneNumber.startsWith('91')) {
  //     return phoneNumber.substring(2);
  //   }
    
  //   return phoneNumber;
  // }
}
